import _ from 'lodash'
import { Disclaimer, ProposalBlock, ProposalSection } from '@vzmi/shp_shared_compo'
import { FormRow } from '../../../Common/Form'
import { Field } from '../../../Common/forms'
import SingleLineText from '../../../Proposal/Common/ReadOnlyComponents/SingleLineText/SingleLineText'
import { ListingFieldConfig, getApplicantFieldProps } from '../../../Proposal/Common/ProposalForm/Shared/FieldConfig'
import { getSupplierFullNameByUser } from '../../../../../lib/proposalHelper'

const Background = props => {
  const {
    user,
    isEditPage,
    withSubStation,
    readOnly
  } = props
  const supplierFullName = getSupplierFullNameByUser(user)
  const identity = _.get(user, 'identity', {})
  return (
    <ProposalSection
      name='proposal-background'
      title='提案背景'
    >
      <ProposalBlock>
        <FormRow
          key='supplierName'
          label='提案廠商'
        >
          <SingleLineText
            content={supplierFullName}
          />
        </FormRow>
        <FormRow
          key='applicant'
          label='提案人'
          withInputCountPaddingBottom={!readOnly}
        >
          <Field
            {...ListingFieldConfig.getField('applicant')}
            {...getApplicantFieldProps(identity, readOnly, true)}
          />
        </FormRow>
        {
          withSubStation && (
            <FormRow
              key='subStationLabel'
              label='提案站別／對象'
              withInputCountPaddingBottom={!readOnly}
            >
              <Field
                name='subStationLabel'
                data-role='sub-station-label'
                component={SingleLineText}
                simpleValue
              />
            </FormRow>
          )
        }
        {
          isEditPage && (
            <FormRow
              // 法律聲明
              key='disclaimer'
              noLabel
            >
              <Disclaimer
                detailsVisible
              />
            </FormRow>
          )
        }
      </ProposalBlock>
    </ProposalSection>
  )
}

export default Background
